import React from "react";
import PropTypes from "prop-types";
import { ReactSVG } from "react-svg";

import { getSocialPlatformLogo, getPlatformColor } from "utils/pageElements/helpers";

import Box from "@mui/material/Box";

const PlatformIcon = ({ type }) => {
  return (
    <Box
      sx={{
        width: "30px",
        height: "30px",

      }}
    >
      <ReactSVG
        src={getSocialPlatformLogo(type)}
        beforeInjection={(svg) => {
          svg.setAttribute('style', `fill: ${getPlatformColor(type)};`);
        }}
      />
    </Box>
  );
};

PlatformIcon.propTypes = {
  type: PropTypes.string.isRequired,
};

export default PlatformIcon;
